module.exports = function(bootstrap) {
    bootstrap.run(["Service", function (Service) {
        var hostnameArray = window.location.hostname.split('.');
        var subDomain = hostnameArray[0].substring(1);
        var currentConfig = subDomain == "ww"? "":"qa";       
        return new Service({
            name: 'createOtp',
            group: "eprsvc",
            //url :'https://login'+currentConfig+'.highmark.com/oam/services/rest/auth/api/v1/mfa/createOTP',
            url:'https://api'+currentConfig+'.hmhs.com/secinn/v1/otp/otpservices/create',
            generateOtp: function(data,token) {   
            //    this.headers={};         
             this.headers= {
                'Authorization': 'Bearer '+ token 
             }
               this.withCredentials = false;  
                return this.post(data);
            }
        });
    }]);
};
